import useExperiment from '@hooks/useExperiment.experiments'
import useIsDarkMode from '@hooks/useIsDarkMode'

function useSelectProductModalV2() {
  const branchId = useExperiment('select-product-modal-v2')
  const isDarkMode = useIsDarkMode()
  return branchId === 'enabled' && !isDarkMode
}

export default useSelectProductModalV2
